/* @flow */

import * as React from 'react';
import {ErrorMessage} from 'shells/form';
import {portal} from '../portal';
import {AlertBox} from '../alert-box';
import {Button, SaveButton} from '../button';
import {Header, Subheader} from '../typography';

import './confirmation-dialog.css';

type Props = {
    title: string,
    message: string | React.Element<*>,
    confirmText?: string,
    cancelText?: string,
    onCancel: () => void,
    onConfirm?: () => void,
    isConfirmDestructive?: boolean,
    isSaving?: boolean,
    customSaveText?: {
        initial: string,
        saving: string,
        complete: string,
    },
    errorMessage?: string,
};

function ConfirmationDialogComponent(props: Props) {
    ConfirmationDialogComponent.defaultProps = {
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        isConfirmDestructive: true,
    };

    let buttonRef = null;

    React.useEffect(() => {
        if (buttonRef) {
            buttonRef.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customSaveText = props.customSaveText ? props.customSaveText : {};

    return (
        <AlertBox onClose={props.onCancel}>
            <div styleName='confirm-box'>
                {props.errorMessage ? (
                    <div styleName='error-message'>
                        <ErrorMessage>{props.errorMessage}</ErrorMessage>
                    </div>
                ) : (
                    undefined
                )}

                <div>
                    <Header>{props.title}</Header>
                    <Subheader as='p'>{props.message}</Subheader>
                </div>
                <div styleName='confirm-buttons'>
                    {props.onCancel ? (
                        <Button
                            variant={props.isConfirmDestructive ? 'text-primary' : 'text-secondary'}
                            onClick={props.onCancel}
                            getButtonRef={(node) => {
                                buttonRef = node;
                            }}
                        >
                            {
                                /* $FlowFixMe upgrading Flow to v0.92.1 on web */
                                props.cancelText
                            }
                        </Button>
                    ) : (
                        undefined
                    )}
                    {props.onConfirm ? (
                        <SaveButton
                            type='button'
                            variant={props.isConfirmDestructive ? 'text-danger' : 'text-primary'}
                            onClick={props.onConfirm}
                            isSaving={Boolean(props.isSaving)}
                            buttonText={
                                customSaveText.initial ? customSaveText.initial : props.confirmText
                            }
                            savingText={customSaveText.saving}
                            successText={customSaveText.complete}
                            disabled={props.errorMessage}
                        />
                    ) : (
                        undefined
                    )}
                </div>
            </div>
        </AlertBox>
    );
}

export const ConfirmationDialog = portal(ConfirmationDialogComponent);
